import {
    StyledSection,
    StyledHeading,
    StyledParagraph,
    BannerContainer,
    LogotypesContainer,
    RightsideContainer,
} from './styles';
import Logotype from '../../components/Logotype/Logotype';

export interface CustomerSectionProps {
    data: string;
}

const CustomerSection: React.FC<CustomerSectionProps> = data => {
    return (
        <StyledSection>
            <BannerContainer>
                <StyledHeading>Dołącz do klubu profesjonalistów</StyledHeading>
                <StyledParagraph $style="normal">
                    Zobacz historię sklepów, które zdecydowały się na IdoSell. Dowiedz się, w jaki
                    sposób dołączyły do grona profesjonalistów i zaczęły sprzedawać więcej.
                </StyledParagraph>
            </BannerContainer>
            <RightsideContainer className="trusted_by__brands">
                <Logotype
                    src="https://www.iai-system.com/panel/file-gate.php?id=287721&ext=.svg"
                    alt="minti logo"
                />
                <Logotype
                    src="https://www.iai-system.com/panel/file-gate.php?id=287739&amp;ext=.svg"
                    alt="LeeCooper logo"
                />
                <Logotype
                    src="https://www.iai-system.com/panel/file-gate.php?id=287740&amp;ext=.svg"
                    alt="Foods by Ann logo"
                />
                <Logotype
                    src="https://www.iai-system.com/panel/file-gate.php?id=287741&amp;ext=.svg"
                    alt="Denley logo"
                />
                <Logotype
                    src="https://www.iai-system.com/panel/file-gate.php?id=287742&amp;ext=.svg"
                    alt="ezebra logo"
                />
                <Logotype
                    src="https://www.iai-system.com/panel/file-gate.php?id=287743&amp;ext=.svg"
                    alt="Pan Pablo logo"
                />
                <Logotype
                    src="https://www.iai-system.com/panel/file-gate.php?id=287744&amp;ext=.svg"
                    alt="9design logo"
                />
                <Logotype
                    src="https://www.iai-system.com/panel/file-gate.php?id=287745&amp;ext=.svg"
                    alt="Paese logo"
                />
            </RightsideContainer>
        </StyledSection>
    );
};

export default CustomerSection;
